import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { TooltipTextModule } from '../tooltip-text/tooltip-text.module';
import { ImportCsvComponent } from './import-csv.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    I18nModule,
    MatIconModule,
    MatTooltipModule,
    IconModule,
    TooltipTextModule,
    RouterModule,
    ImportCsvComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoCartImportComponent: {
          component: ImportCsvComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ImportCsvComponent],
})
export class ImportCsvModule {}
